export default __webpack_public_path__ + "static/media/Certificate of RTA under Regulation 74(5).767babb3.pdf";